import Box from "@mui/material/Box";
import FilterComponent from "../../../../../ReusableFIlterComponent/FilterComponent";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setRequestedBy,
  setSelectedStatus,
} from "../../../../../../features/pageSpeedPerformanceSlice";

interface Props {
  rows: any;
  setSelectedSearchValue: any;
}

export default function PageScanRequestFilter({
  rows,
  setSelectedSearchValue,
}: Props) {
  const [searchStatus, setSearchStatus] = useState("");
  const [searchRequestedBy, setSearchRequestedBy] = useState("");
  const { selectedStatus, requestedBy } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  const dispatch = useDispatch();
  const filterConfig = [
    {
      key: "scan status",
      label: "Select Scan Status",
      searchTerm: searchStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchStatus(e.target.value),
      selectedOption: selectedStatus,
      filterName: "active",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedStatus(updatedSelection)),
      count: selectedStatus && selectedStatus.length,
      colorSelected:
        selectedStatus !== null && selectedStatus.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: false,
      showSearch: false,
      valueMapping: { true: "Active", false: "Inactive" },
    },
    {
      key: "requested by",
      label: "Select a user",
      searchTerm: searchRequestedBy,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchRequestedBy(e.target.value),
      selectedOption: requestedBy,
      filterName: "created_by",
      data: rows,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setRequestedBy(updatedSelection)),
      count: requestedBy && requestedBy.length,
      colorSelected:
        requestedBy !== null && requestedBy.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
  ];

  const clearFilters = () => {
    dispatch(setSelectedStatus(null));
    dispatch(setRequestedBy(null));
    setSelectedSearchValue(null);
  };

  return (
    <Box data-tracker="161">
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
        paginationKey="pageScanPage"
      />
    </Box>
  );
}
